export function langSwitcher() {
    $(window).on("load", () => {
        setTimeout(() => {
            const langSelect = $(".goog-te-combo");
            langSelect.addClass("jcf-ignore");
        }, 1000);
    });
    $(window).on("load", () => {
        setTimeout(() => {
            changeLang();
        }, 1000);
    });
    function changeLang() {
        const flags = $("#flags");
        const langLabel = $(".lang-label");
        $(".lang-switcher").on("click", () => {
            flags.toggleClass("active");
        });
        flags.find("li").on("click", (event) => {
            langLabel.text($(event.target).data("lang"));
        });
        $(document).on("click", (event) => {
            if(!$(event.target).closest(".lang-switcher").length) {
                flags.removeClass("active");
            };
        });
    }
    $(window).on("scroll", function() {
        $("#flags").removeClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/langSwitcher.js